export { default as Polygon } from './polygon';
export { getPolygonSignedArea, getPolygonWindingDirection, forEachSegmentInPolygon, modifyPolygonWindingDirection, WINDING } from './polygon-utils';
export { earcut } from './earcut';
export { clipPolygon, clipPolyline } from './lineclip';
export { cutPolygonByGrid, cutPolylineByGrid } from './cut-by-grid';
export { cutPolylineByMercatorBounds, cutPolygonByMercatorBounds } from './cut-by-mercator-bounds';
export { default as _Polygon } from './polygon';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@math.gl/polygon/dist/esm/index.js